<template>
  <div class="plv-iar-product pws-aside-bg-color pws-iar-product-list-wrap">
    <div
      ref="productContent"
      class="plv-iar-product__content pws-iar-product-list-content pws-chat-scroll-color"
      @scroll="handleScroll"
    >
      <div class="plv-iar-product__top plv-iar-product__list-header-padding-x-16">
        <!-- 搜索 -->
        <iar-input
          class="plv-iar-product__top__search"
          v-model="keyword"
          :placeholder="iarTrans('product.searchPlaceholder')"
        >
          <icon-search slot="prefix" class="plv-iar-product__top__search__icon" />
        </iar-input>
        <template v-if="!isKeywordSearch">
          <!-- 标签选择 -->
          <pc-label-list v-model="currentTagId" :product-sdk="productSdk" />
          <!-- 总数 -->
          <product-total v-if="totalVisible && products.length" :total="total" />
        </template>
      </div>
      <template v-if="hasTopping">
        <product-item
          :number="toppingProduct.rank"
          :good="toppingProduct"
          :content-width="contentWidth"
          is-top
          @job-detail="clickJobDetail"
          @click-product="clickProduct"
        />
      </template>
      <template v-if="products.length">
        <product-item
          v-for="(good) in products"
          :key="good.productId"
          ref="productItem"
          :number="good.showId"
          :good="good"
          :hide-number="!good.showId"
          :content-width="contentWidth"
          @job-detail="clickJobDetail"
          @click-product="clickProduct"
        />
      </template>
      <template v-else-if="isLoading && isFirstLoadDone">
        <div class="plv-iar-product__list-loading-wrap">
          <product-list-loading :text="keyword ? iarTrans('product.searching') : iarTrans('product.loading')" />
        </div>
      </template>
      <template v-else-if="!products.length && isFirstLoadDone">
        <product-empty :is-keyword-search="isKeywordSearch" />
      </template>
    </div>
  </div>
</template>

<script>
import mixin from './mixin';
import IarInput from '../../components/common/iar-input/iar-input.vue';
import ProductListLoading from '../../components/product/list/ProductListLoading.vue';
import ProductEmpty from '../../components/product/list/ProductEmpty.vue';
import ProductTotal from '../../components/product/list/ProductTotal.vue';
import ProductItem from '../../components/product/list/ProductItem.vue';
import PcLabelList from './components/label-list/PcLabelList.vue';
import { IconSearch } from '@/icon-components/map';

export default {
  components: {
    IarInput,
    ProductEmpty,
    ProductTotal,
    ProductItem,
    PcLabelList,
    IconSearch,
    ProductListLoading,
  },

  mixins: [mixin],
};
</script>

<style lang="scss">
@import '../../assets/styles/basic';

.plv-iar-product {
  width: 100%;
  height: 100%;
  position: relative;
  background: #202127;
  box-sizing: border-box;
}

.plv-iar-product__content {
  width: 100%;
  height: 100%;
  position: relative;
  box-sizing: border-box;
  background-color: #1a1a1f;
  overflow-y: auto;
  @include scrollbar(inherit, inherit, #46464f, inherit);
  ::-webkit-scrollbar-thumb {
    border-radius: 8px;
  }
  ::-webkit-scrollbar-track {
    border-radius: 8px;
  }
}
.plv-iar-product__top {
  position: sticky;
  top: 0;
  left: 0;
  z-index: 30;
  background-color: inherit;
  padding-top: 14px !important;
  padding-bottom: 1px !important;
}

.plv-iar-product__top__search {
  margin-bottom: 16px;
}
.plv-iar-product__top__search__icon {
  font-size: 16px;
  display: flex;
  margin-right: 4px;
  color: rgba(#fff, 0.3);
}
.plv-iar-product__list-loading-wrap {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  pointer-events: none;
  display: flex;
  align-items: center;
  justify-content: center;
}
.plv-iar-product__list-header-padding-x-16 {
  padding: 0 16px;
}

.plv-iar-product__content {
  .plv-iar-product__item__price-tag {
    color: rgba(255, 255, 255, 0.4) !important;
  }
  .plv-iar-product__buy-button--disabled .plv-iar-product__item__btn__content {
    background: #FFA1A1 !important;
  }
}
</style>
